/**
 * Today preview for scrollytelling — same app UI with fixture data, interactions disabled.
 */

import * as React from "react";
import { DemoErrorBoundary } from "@/components/landing/demos/DemoErrorBoundary";
import { DemoInteractionGuard } from "@/components/landing/demos/DemoInteractionGuard";
import { mockTodayActions } from "@/components/landing/demos/mockTodayData";
import { TodayView, type TodayViewAction } from "@/features/today/TodayView";

export function TodayPreview() {
  const actions: TodayViewAction[] = mockTodayActions;

  return (
    <div className="dark min-h-[320px] pointer-events-none select-none">
      <DemoErrorBoundary>
        <DemoInteractionGuard className="relative">
          <TodayView actions={actions} mode="demo" />
        </DemoInteractionGuard>
      </DemoErrorBoundary>
    </div>
  );
}
